import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MapPin, Clock, Phone } from "lucide-react";

export default function Stores() {
  const [stores, setStores] = useState([]);
  useEffect(() => { api.get("/stores").then(r => setStores(r.data)); }, []);

  return (
    <div className="bg-ivory text-ink pt-32 pb-24">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        <div className="text-center mb-24">
          <p className="text-[10px] tracking-luxury uppercase text-gold mb-6">Visit</p>
          <h1 className="font-editorial text-5xl md:text-8xl leading-[0.95] tracking-tight">The Boutiques</h1>
          <div className="rule-gold w-32 mx-auto my-10" />
          <p className="max-w-2xl mx-auto text-ink/70 leading-relaxed">Every LOOXS piece is presented, fitted and delivered from a private boutique. Visit us by appointment.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-black/10">
          {stores.map((s, i) => (
            <div key={s.name} data-testid={`store-${s.city.toLowerCase()}`} className="bg-ivory p-10 md:p-14 animate-fade-up" style={{ animationDelay: `${i*80}ms` }}>
              <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">{s.city}</p>
              <h3 className="font-editorial text-3xl md:text-4xl leading-tight">{s.name}</h3>
              <div className="rule-gold w-12 my-6" />
              <ul className="space-y-4 text-sm text-ink/80">
                <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-gold" strokeWidth={1.25} /> {s.address}</li>
                <li className="flex gap-3"><Clock className="w-4 h-4 mt-0.5 text-gold" strokeWidth={1.25} /> {s.hours}</li>
                {s.phone && <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-gold" strokeWidth={1.25} /> {s.phone}</li>}
              </ul>
              <a href={`mailto:care@looxsfashion.com?subject=Appointment%20-%20${encodeURIComponent(s.name)}`}
                 className="inline-block mt-8 tracking-widest-plus text-[11px] uppercase link-draw">
                Request an appointment →
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
